import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { SeasonRegistryResource } from '~~apis/resource';
import Loading from '~~elements/Loading';
import Registry from './Registry';
import RMultilingual from './Multilingual';
import { RegistryProvider } from './useRegistry';
import { useTournamentState } from '../useTournament';

const LoadingDiv = styled.div`
  width: 100%;
  text-align: center;
  padding: 5rem 0;
  font-size: 1.2rem;
`;

const Index = ({ organizer }) => {
  const { tournamentInfo } = useTournamentState();

  const [registryInfo, setRegistryInfo] = useState(null);
  const [errorCode, setErrorCode] = useState('');

  useEffect(() => {
    if (!tournamentInfo.uniqid) {
      return;
    }

    const initRegistryInfo = () => {
      SeasonRegistryResource.initRegistry({ seasonUniqid: tournamentInfo.uniqid })
        .then(({ data }) => {
          setRegistryInfo(data);
        })
        .catch((e) => {
          setErrorCode(e.message);
          return;
        });
    };

    SeasonRegistryResource.getRegistry({ seasonUniqid: tournamentInfo.uniqid })
      .then(({ data }) => {
        if (!data.uniqid) {
          return initRegistryInfo();
        }
        setRegistryInfo(data);
      })
      .catch((e) => {
        setErrorCode(e.message);
        return;
      });
  }, [tournamentInfo.uniqid]);

  if (errorCode) {
    return <LoadingDiv>{RMultilingual(`COMMON.UNKNOWN_ERROR`)}</LoadingDiv>;
  }

  if (!registryInfo) {
    return (
      <LoadingDiv>
        <Loading width="30vw" />
      </LoadingDiv>
    );
  }

  return (
    <RegistryProvider>
      <Registry organizer={organizer} registryInfo={registryInfo} />
    </RegistryProvider>
  );
};

export default Index;
